/**
 * Gantt view constants and configuration
 */

export const MS_PER_DAY = 1000 * 60 * 60 * 24;
export const MS_PER_HOUR = 1000 * 60 * 60;

// Zoom levels in order (most zoomed in to most zoomed out)
export const ZOOM_LEVELS = ['hour-detail', 'hour', 'day-detail', 'day', 'week', 'month', 'quarter', 'year'];

// Timeline scale multipliers (higher = wider = more zoomed in)
export const ZOOM_SCALES = {
  'hour-detail': 48,
  'hour': 24,
  'day-detail': 6,
  'day': 2,
  'week': 1,
  'month': 0.5,
  'quarter': 0.25,
  'year': 0.1,
};

// Padding days for each zoom level (reasonable defaults)
export const ZOOM_PADDING = {
  'hour-detail': 1,
  'hour': 2,
  'day-detail': 7,
  'day': 14,
  'week': 30,
  'month': 60,
  'quarter': 90,
  'year': 180,
};

// Range presets for quick navigation (auto-zoom buttons)
export const RANGE_PRESETS = [
  { id: 'today', label: 'Today' },
  { id: 'this-week', label: 'This Week' },
  { id: 'this-month', label: 'This Month' },
  { id: 'this-quarter', label: 'This Quarter' },
  { id: 'this-year', label: 'This Year' },
  { id: 'all', label: 'All Tasks' },
];
